import Vue from 'vue';
import App from './App.vue';
import moment from 'vue-moment';
import router from './router';
import store from './store';

import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import Notifications from 'vue-notification';
import VueHotkey from 'v-hotkey';

import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import VueSelect from 'vue-select';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend( utc );
dayjs.extend( timezone );
dayjs.extend( customParseFormat );
dayjs.tz.setDefault( 'Europe/Madrid' );

const isProduction = process.env.NODE_ENV === 'production';

if ( isProduction ) {
    Sentry.init( {
        dsn: 'https://ac020ec2a49f46fda6dab5e99c70e8ea@o19988.ingest.sentry.io/1220723',
        integrations: [
            new BrowserTracing( {
                routingInstrumentation: Sentry.vueRouterInstrumentation( router )
            } )
        ],
        tracesSampleRate: 1.0
    } );
}

/**
 * Configuration
 */
Vue.config.productionTip = isProduction;

/**
 * Register Components
 */
Vue.use( moment );
Vue.use( Notifications );
Vue.use( VueHotkey );

Vue.component( 'vue-typeahead-bootstrap', VueTypeaheadBootstrap );
Vue.component( 'v-select', VueSelect );

/**
 * Initialise new Vue application
 */
new Vue( {
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    render: h => h( App )
} );



// WEBPACK FOOTER //
// ./src/main.js